import { PrimaryColors } from 'src/types/globalTypes';
import DropdownInfo from 'src/components/ui-kit/DropdownInfo';
import { TwinsApprove } from 'src/types/api/patentRightsApiTypes';
import { Table, Item, Title, Content } from 'src/components/contents/detail/DetailPage';

interface Iprops {
  data: TwinsApprove;
  isShow: boolean;
  setIsShow: (isShow: boolean) => void;
  colorType: PrimaryColors;
  noContent: JSX.Element;
}

/**
 * 專利一案兩請關聯案件 區塊。
 */
const InfoPatentTwinsApprove: React.FC<Iprops> = ({
  data,
  isShow,
  setIsShow,
  colorType,
  noContent,
}) => {
  const tableColor = colorType.third;
  const angleColor = colorType.fifth;
  return (
    <DropdownInfo
      title={`專利一案兩請關聯案件`}
      isShow={isShow}
      setIsShow={setIsShow}
      color={angleColor}
    >
      <Table color={tableColor}>
        <Item>
          <Title>專利權消滅之新型專利申請案號</Title>
          <Content>{data.applyNo || noContent}</Content>
          <Title>發明專利申請案號</Title>
          <Content>{data.twinsApplyNo || noContent}</Content>
        </Item>
      </Table>
    </DropdownInfo>
  );
};

export default InfoPatentTwinsApprove;
